import { useEffect, useState } from "react";
import useEditData from "../../../hooks/useEditData";
import useAddData from "../../../hooks/useAddData";
import { useFormik } from "formik";
import { handleKeyDown } from "../../../utils/OtherFunctions";
import { CloseIcon } from "../../../assets/icons";
import { CancelButton, SubmitButton } from "../../../utils/Button";
import FormikSelectTwo from "../../../utils/Select";
import { NuInput, NuUpload } from "../../../utils/Inputs";
import FileDisplay from "../../../utils/FileDisplay";

export default function CreateorUpdate({
  data,
  visible,
  onClose,
  refreshData,
  vendorList,
}) {
  const { isCreateLoading, addData } = useAddData();
  const { isEditLoading, editData } = useEditData();
  const [selectedFile, setSelectedFile] = useState(null);
  const [filePathList, setFilePathList] = useState([]);
  const [removefilePathList, setRemoveFilePathList] = useState([]);
  const [createNew, setCreateNew] = useState({
    vendor_name: "",
    vendor_type: "",
  });

  useEffect(() => {
    setCreateNew({
      vendor_name: data?.vendor_name,
      vendor_type: data?.vendor_type,
    });
    setFilePathList(data?.document_type);
    setRemoveFilePathList(data?.document_type);
  }, [data]);

  function handleImageChange(e) {
    const files = Array.from(e.target.files);
    setSelectedFile(files);
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNew,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: (value, { resetForm }) => {
      if (data?.id) {
        let formData = new FormData();
        if (selectedFile !== null) {
          selectedFile.forEach((file) => {
            formData.append("document_type", file);
          });
        }
        formData.append("vendor_management", JSON.stringify(value));
        editData({
          url: `/Vendor-Management/update/${data?.id}`,
          value: formData,
          resetForm: resetForm,
          onClose: onClose,
          getData: refreshData,
          hasFile:true,
          setSelectedFile: setSelectedFile,
        });
      } else {
        let formData = new FormData();
        if (selectedFile !== null) {
          selectedFile.forEach((file) => {
            formData.append("document_type", file);
          });
        }
        formData.append("vendor_management", JSON.stringify(value));
        addData({
          url: `/Vendor-Management/add`,
          value: formData,
          resetForm: resetForm,
          onClose: onClose,
          getData: refreshData,
        });
      }
    },
  });

  function UpdateAttachmentList(item) {
    let filterList = filePathList.filter((itemList) => itemList !== item);
    setFilePathList(filterList);
  }

  const resetClose = () => {
    formik.resetForm();
    onClose();
  };

  if (!visible) return null;

  return (
    <>
      <div
        id="modal"
        className="bg-black bg-opacity-30 fixed z-10 inset-0 backdrop-blur-sm 
        flex justify-center items-center "
      >
        <div className="bg-white mt-12 p-2 rounded-xl w-4/12">
          <div className="flex items-start justify-between px-5 py-2  rounded-t">
            <h3 className="text-base 2xl:text-lg font-semibold">
              {data ? "Edit" : "New"}
            </h3>
            <span
              className="h-6 w-6 text-2xl block cursor-pointer"
              onClick={onClose}
            >
              <CloseIcon />
            </span>
          </div>
          <form onSubmit={formik.handleSubmit} onKeyDown={handleKeyDown}>
            <div className="relative   max-h-[calc(100vh-180px)] overflow-y-auto  flex flex-wrap justify-between text-left">
            <NuInput
                  formik={formik}
                  name="vendor_name"
                  label="Vendor Name"
                  width="w-full"
                  placeholder="Vendor Name"
                />
            <FormikSelectTwo
                formik={formik}
                name="vendor_type"
                label="User"
                width="w-full"
                placeholder="Select Vendor Type"
                Options={vendorList}
                zindex={12}
              />
              <NuUpload
                  label="Documents Type - NDA, Contract"
                  width="w-full"
                  onChange={handleImageChange}
                  multiple={true}
                />
              <div className=" w-full flex flex-wrap ">
                {data?.document_type &&
                  filePathList.map((i) => {
                    return (
                      <div className=" m-1 my-3">
                        <div className=" relative">
                          <div
                            className=" w-4 h-4 rounded bg-slate-400 absolute text-white cursor-pointer font-bold flex justify-center items-center  -top-2 right-2 z-10"
                            onClick={() => UpdateAttachmentList(i)}
                          >
                            -
                          </div>
                          <FileDisplay data={i} view={true}/>
                        </div>
                      </div>
                    );
                  })}
              </div>
              <div className=" w-full flex items-center px-3 justify-end pb-6 rounded-b">
                <CancelButton
                  onClose={resetClose}
                  isLoading={isCreateLoading || isEditLoading}
                />
                <SubmitButton isLoading={isCreateLoading || isEditLoading} />
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
